export default [
    {
        path: `/bulk/merge_people`,
        component: () => import('@/pages/bulk/Merge.vue'),
        meta: {
            isVue: true,
            sideNav: `bulk`
        }
    },
    {
        path: `/bulk/update_people`,
        component: () => import('@/pages/Blank.vue'),
        meta: {
            isLegacyRoute: true,
            sideNav: `bulk`
        }
    },
    {
        path: `/bulk/import_people`,
        component: () => import('@/pages/Blank.vue'),
        meta: {
            isLegacyRoute: true,
            sideNav: `bulk`
        }
    },
    {
        path: `/bulk/import_tags`,
        component: () => import('@/pages/Blank.vue'),
        meta: {
            isLegacyRoute: true,
            sideNav: `bulk`
        }
    },
    {
        path: `/bulk/import_pledges`,
        component: () => import('@/pages/Blank.vue'),
        meta: {
            isLegacyRoute: true,
            sideNav: `bulk`
        }
    },
    {
        path: `/bulk/import_giving/generic`,
        component: () => import('@/pages/Blank.vue'),
        meta: {
            isLegacyRoute: true,
            sideNav: `bulk`
        }
    },
    {
        path: `/bulk/import_attendance`,
        component: () => import('@/pages/Blank.vue'),
        meta: {
            isLegacyRoute: true,
            sideNav: `bulk`
        }
    },
    {
        path: `/bulk/import_users`,
        component: () => import('@/pages/Blank.vue'),
        meta: {
            isLegacyRoute: true,
            sideNav: `bulk`
        }
    },
    {
        path: `/bulk/import_notes`,
        component: () => import('@/pages/Blank.vue'),
        meta: {
            isLegacyRoute: true,
            sideNav: `bulk`
        }
    },
    {
        path: `/bulk/import_barcodes`,
        component: () => import('@/pages/Blank.vue'),
        meta: {
            isLegacyRoute: true,
            sideNav: `bulk`
        }
    },
    {
        path: `/bulk/delete`,
        component: () => import('@/pages/Blank.vue'),
        meta: {
            isLegacyRoute: true,
            sideNav: `bulk`
        }
    }
]
